import { create } from '@thoughtspot/logger';
import { createContext, useContext } from 'react';
const logger = create('Blink Context');
export let BlinkContext;
function initBlinkContext() {
    var _a, _b;
    if ((_a = window === null || window === void 0 ? void 0 : window.blink) === null || _a === void 0 ? void 0 : _a.BlinkContext) {
        BlinkContext = (_b = window === null || window === void 0 ? void 0 : window.blink) === null || _b === void 0 ? void 0 : _b.BlinkContext;
    }
    else {
        BlinkContext = createContext({
            setNavService: navService => {
            },
        });
        window.blink = window.blink || {};
        window.blink.BlinkContext = BlinkContext;
    }
}
export function useBlinkContext() {
    const blinkContext = useContext(BlinkContext);
    if (!blinkContext.metricsService) {
        logger.error('No Blink Context Provided in this tree.');
    }
    return blinkContext;
}
initBlinkContext();
//# sourceMappingURL=blink-context.js.map